import React, { useEffect, useState } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { GetServiceCaller, PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";

const ViewPRStatus = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const responses = [
    {
      srNo: 1,
      question: "What is your opinion about the work environment?",
      type: "textarea",
      defaultValue: "The environment is great.",
    },
    {
      srNo: 2,
      question: "Which benefits do you value the most? (Choose one)",
      type: "radio",
      options: [
        "Health Insurance",
        "Paid Time Off",
        "Retirement Plan",
        "Flexible Working Hours",
        "Education Assistance",
      ],
    },
    {
      srNo: 3,
      question:
        "Which of the following tools do you use? (Select all that apply)",
      type: "checkbox",
      options: ["Slack", "Zoom", "GitHub", "Jira", "Trello"],
    },
  ];


  useEffect(()=>{
    if(id){
        fetchPrEvaluationReport(id)
    }
  },[id])
  const fetchPrEvaluationReport = async () => {
    setLoading(true);

    try {
      const response = await PostServiceCaller(
        `${API_URL}fetch-performance-evaluation-details`,
        {
          performance_evaluation_id: id,
        },
        "post"
      );
    } catch (err) {}
  };

  const renderResponse = (response) => {
    if (response.type === "textarea") {
      return (
        <textarea disabled defaultValue={response.defaultValue} rows={3} />
      );
    } else if (response.type === "radio") {
      return (
        <div>
          {response.options.map((option, index) => (
            <div key={index}>
              <input type="radio" name={`radio-${response.srNo}`} disabled />{" "}
              {option}
            </div>
          ))}
        </div>
      );
    } else if (response.type === "checkbox") {
      return (
        <div>
          {response.options.map((option, index) => (
            <div key={index}>
              <input
                type="checkbox"
                name={`checkbox-${response.srNo}`}
                disabled
              />{" "}
              {option}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <div>
        <div className="Nav">
          <Navbar heading={`Performance Evaluation`} />
        </div>
        <div className="nest-page">
          <SideBar />
          <div className="container-fluid" id="skill_section">
            <div className="container-fluid" id="skill-table-area">
              <div className="row mt-2 mr-3">
                <div className="text-end">
                  <div className="justify-content-center">
                    <button className="custom-btn">
                      <i class="bi bi-printer"></i> Print
                    </button>
                  </div>
                </div>
              </div>
              <div className="row mt-1 mr-">
                <h4 className="text-bold">Sneha Jadhav</h4>
              </div>
              <div className="row mt-1 mr-3">
                <div className="row">
                  <div className="col-4">
                    <i class="bi bi-file-earmark"></i>
                    <span> Hire Date: 21-03-2023</span>
                  </div>
                  <div className="col-4">
                    <i class="bi bi-calendar-plus"></i>{" "}
                    <span> Evaluation Date: 21-03-2023</span>
                  </div>
                  <div className="col-4">
                    <span> Appraisal Cycle: APR 2022- 2023</span>
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-4">
                    <i class="bi bi-calendar-plus"></i>
                    <span> Reviewer</span>
                  </div>
                  <div className="col-4">
                    <i class="bi bi-calendar-plus"></i>{" "}
                    <span> Review Date: 21-03-2023</span>
                  </div>
                </div>
              </div>
              <div className="row mx-2 mt-2">
                <Table bordered hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th>#</th>
                      <th>Employee Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responses.map((response, index) => (
                      <tr key={index}>
                        <td>{response.srNo}</td>
                        <td>
                          <div>
                            <strong>Question:</strong> {response.question}
                          </div>
                          <div>{renderResponse(response)}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPRStatus;
